import React from "react";

const Defence = ({
  width = 15,
  height = 19,
  stroke = "#2F6AF5",
  strokeWidth = 1.65,
  strokeLinecap = "round",
  strokeLinejoin = "round",
}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EC28FE" fill-opacity="0.1" />
      <path
        d="M25.3055 10.95L13.5605 15.5175V24C13.5605 28.5675 18.128 35.745 24.0005 37.05C29.873 35.745 34.4405 28.5675 34.4405 24V15.5175L24.0005 10.95H25.3055Z"
        stroke="#EC28FE"
        stroke-width="2.16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Defence;
